import Navbar from '@/components/Navbar'

export const detail = [
    {
        path: '/detail',
        redirect: '/detail/index',
        component: Navbar,
        children: [{
            path: '/detail/index',
            component: ()=>import('@/views/detail/index')
        }]
    }
]